/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_NewInputs */

const cs_tasks_new = /** @type {(inputs: Tasks_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový úkol`)
};

const en_tasks_new = /** @type {(inputs: Tasks_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Tasks_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_new = /** @type {((inputs?: Tasks_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_new(inputs)
	return cs_tasks_new(inputs)
});